import angular from 'angular';

angular
  .module('commonServices')
  .constant('timerConfig', {
    tickEvent: 'timer-service-tick',
    storageKey: 'clx-timerData',
  })
  .factory('timerSvc', ['$interval', '$rootScope', 'timerConfig', timerSvc]);

function timerSvc($interval, $rootScope, timerConfig) {
  var initialized = false;

  var subscribe = function(scope, callback) {
    var handler = $rootScope.$on(timerConfig.tickEvent, callback);
    scope.$on('$destroy', handler);
  };
  var notify = function() {
    $rootScope.$emit(timerConfig.tickEvent);
  };

  //Called every minute
  var tick = function() {
    notify();
  };

  //Called when service is created
  var init = function() {
    if (initialized) return;
    initialized = true;
    //Start timer
    $interval(tick, 60000);
  };

  return {
    subscribe: subscribe,
    init: init,
  };
}
